import { FC, useState } from "react"
import { useNavigate } from "react-router-dom"
import { IStudent } from "types"
import { t } from "i18next"

import { Box, Grid } from "@mui/material"
import { Check, RadioButtonUnchecked } from "@mui/icons-material"

import ActionPlanForm from 'components/organisms/forms/special/ActionPlanForm'
import StrategiesMethodsForm from 'components/organisms/forms/special/StrategiesMethodsForm'
import TrainingScheduleForm from 'components/organisms/forms/special/TrainingScheduleForm'
import ReportGoalsForm from 'components/organisms/forms/special/ReportGoalsForm'
import SessionForm from 'components/organisms/forms/special/SessionForm'
import ProgressMonitoringForm from 'components/organisms/forms/special/ProgressMonitoringForm'


interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const IEPIntervention: FC<IProps> = ({ student }) => {

    const navigate  =  useNavigate()

    const [step, setStep] = useState(0)

    const steps = [
        {title: t('special.action-plan'), checked: false, component: <ActionPlanForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.strategies-and-methods'), checked: false, component: <StrategiesMethodsForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.training-schedule'), checked: false, component: <TrainingScheduleForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.report-on-goals'), checked: false, component: <ReportGoalsForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.sessions'), checked: false, component: <SessionForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('rti.progress-monitoring'), checked: false, component: <ProgressMonitoringForm action={'add'} id={''} viewOnly={false} /> },
    ]


    return <div style={{ padding: '0px' }}>    
        <Grid container>
            <Grid item xs={12} lg={3}>
                <div style={{ padding: '20px' }}>
                    <div style={{ padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '5px' }}>
                        {steps.map((s, index) => <Box 
                            className='transparent-background' 
                            onClick={() => setStep(index)}
                            sx={{ 
                                display: 'flex', 
                                cursor: 'pointer', 
                                marginBottom: '20px',
                                fontWeight: step === index ? 'bold' : 'normal',
                                '&:hover': {
                                    fontWeight: 'bold'
                                }
                            }}>
                                {s.checked && <Check sx={{ color: '#7ED321', fontSize: '20px', marginRight: '10px' }} />}
                                {!s.checked && <RadioButtonUnchecked sx={{ fontSize: '20px', marginRight: '10px'  }} />}
                                {index+1}. {s.title}
                        </Box>)}
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} lg={9}>
                <div style={{ padding: '20px' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px'}}>{step+1}. {steps[step].title}</div>
                    {steps[step].component}    
                </div>
            </Grid>
        </Grid>
    </div>
}
export default IEPIntervention